import React, { useState, useContext } from 'react'

import StoreContext     from '../storage/context';
import AlertCustom      from '../alertCustom/index.js'
import NavigationBar    from '../navigationBar/index.js'
import ManualFileForm   from '../manualFileForm/index.js'

import './styles.css'

const ManualFileRegister = () => {
    const { pk_user, givenName, pk_service } = useContext(StoreContext);

    // state for display alert to users
    const [alert, setAlert]         = useState({header: '', message: '', type: '', options_btn: []});
    const [showAlert, setShowAlert] = useState(false);

    // variables used for save manual file
    const [fields, setFields]   = useState([])
    const [data, setData]       = useState({
        is_project: '',
        justification_ingestion: '',
        project_name: '',
        requesting_area: '',
        requesting_company: '',
        requesting_email: '',
        requesting_name: '',
        have_permission: '',

        area_for_business_data: '',
        company: '',
        domain_data: '',
        public_data: '',
        subject_data: '',
        responsible_for_business_data: '',

        maximum_data_history_time: '',
        maximum_data_history_time_unit: '',
        delimiter: '',
        desc_entity: '',
        entity_name: '',
        extension_file: '',
        encoding: 'utf-8',
        frequency: '',
        type_load: '',
        pattern_file: "{entity_name}_{pattern_date}",

        // campo com valores fixos
        source_type: 'arquivos manuais',
        source_name: 'arquivos manuais',
        fk_user: pk_user,
        pk_user: pk_user,
        given_name: givenName,

        // fields to save in dynamo entity
        system_name: 'arquivos_manuais',
        account_destination: 'coe',
		datalake_destination: 'trusted',
        chunk_size: "256000000",
        pattern_date: '%Y%m%d',
        source_path: '{entity_name}',
        active: true,
        header: true,
        version: 0,
        name_responsible_validation: '',
        email_responsible_validation: '',
        validation_date: '',
        validation_status: '',
        desc_validation: '',

        // campos que não serão usados p/ arquivos manuais
        responsible_for_technical_data: '',
        area_for_technical_data: '',
        target_location: '',
        source_external: '',
        business_rules: '',
        related_entity: '',
        data_filter_source: '',
        primary_key_reuse: '',
        record_deletion_allowed: '',
        pattern_data: ''
    })

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'cadastro arquivos manuais',
            'link': `/cadastro-arq-manual?service_id=${pk_service}`
        },
        {
            'nome': 'cadastrar',
            'link': '/cadastro-arq-manual/cadastrar'
        }
    ]

    return (
        <div className="mf-register-container">

            {/* BARRA DE NAVEGAÇÃO */}
            <NavigationBar navegation={navegation} />

            {/* ALERT CUSTOM */}
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            {/* FORMS */}
            <ManualFileForm 
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                setAlert={setAlert}
                action={"Create"}
                readOnly={false}
                fields={fields}
                setFields={setFields}
                data={data}
                setData={setData}
            />

        </div>
    );
}

export default ManualFileRegister;
